import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ChartType, FormControlsOf, ItemChart, ItemColumn, Multilingual } from '@digilize/shared/definitions/src';
import { I18nService } from '@digilize/shared/feature/modules/i18n/src';
import { Chart, ExportingMimeTypeValue, Options } from 'highcharts';

@Component({
  selector: 'suc-charts-group',
  templateUrl: './charts-group.component.html',
  styleUrls: ['./charts-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChartsGroupComponent implements OnInit {
  @Input() chartSelectOptions: { key: string; value: string }[] = [];
  @Input() isData = false;
  @Input() itemCharts: ItemChart[];
  @Input() formGroup: FormGroup<FormControlsOf<ChartFormValues>>;
  @Input() isLoading = false;
  @Input() textHeader: string;

  @Input() set chartExportData(chartExportData: ChartExportData) {
    this.activeChart.chartExportData = chartExportData;
  }
  activeChart = {} as { item: ItemChart; chartExportData: ChartExportData };
  ChartType = ChartType;

  constructor(private i18nService: I18nService) {}

  ngOnInit(): void {
    this.setFormGroupListener();
  }

  private setFormGroupListener() {
    const { charts, id } = this.formGroup.value;
    this.activeChart.item = charts.find((chart) => chart.id === id);

    this.formGroup.valueChanges.subscribe((value) => {
      this.activeChart.item = value.charts.find((chart) => chart.id === value.id);
    });
  }

  isSelectVisible(): boolean {
    return (
      this.chartSelectOptions.length > 1 &&
      this.activeChart.item.labels_visible &&
      this.activeChart.item.type !== ChartType.Comparison360
    );
  }

  exportChart(type: ExportingMimeTypeValue) {
    const { chart, options } = this.activeChart.chartExportData;
    chart.exportChart(
      {
        type,
        filename: options.exporting.filename,
      },
      options
    );
  }

  getItemTitle(multi: Multilingual) {
    const el = this.i18nService.getTextFromMultilingual(multi);
    return el;
  }
}

export interface ChartExportData {
  chart: Chart;
  options: Options;
}

export interface ChartFormValues {
  label: string;
  id: string;
  charts: ItemChart[];
}
export interface ItemColumnWithChart extends ItemColumn {
  itemCharts: ItemChart[] | null;
  chartFg: FormGroup<FormControlsOf<ChartFormValues>> | null;
}
